import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'

import '@nrk/core-fonts/core-fonts.css'
import './components/var.css'
import './components/main/main.module.css'
import './components/main/title/title.module.css'
import './components/main/title/title-container.module.css'
import './components/main/sok/sok.module.css'
import './components/main/sok/emneknagger/emneknagger.module.css'
import './components/main/sok/emneknagger/emneknagg.module.css'
import './components/main/sok/resultat/sokeresultat.module.css'
import './components/common/stillingskort/stillingkort.module.css'
import './components/common/plugg/plugg.module.css'
import './components/common/background/background.module.css'
import './components/common/parallax/parallax.module.css'
import './components/stilling/stilling-page.module.css'
import './components/stilling/bildesveip.module.css'
import './components/stilling/anbefalinger/anbefalinger.module.css'
import './components/stilling/plugger/plugger.module.css'
import './components/stilling/emneknagger/emneknagger.module.css'
import './components/stilling/poll/poll.module.css'
import './components/common/header/header-navigation.module.css'
import './components/common/footer/footer.module.css'
import './components/spesialmoduler/stillinger/enkel/stilling-spesialmodul.module.css'
import './components/spesialmoduler/stillinger/liste/liste-spesialmodul.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)
const tagSpesialmodul = getElementTag(`${__APP_NAME__}-spesialmodul`, __APP_VERSION__)

class AppElement extends BaseElement {
  name = tag
  timer

  connectedCallback() {
    super.connectedCallback()
    this.sendPageView(location.pathname)
    this.addEventListener('dialog.toggle', this.handleDialogToggle)
    this.addEventListener('dh-basis-sveip-active-changed', this.handleActiveChanged)

    document.body.addEventListener('scroll', this.showScrollingAttribute)
    window.addEventListener('scroll', this.showScrollingAttribute)

    this.setupHappyPing()

    if (window.sanityPreview) {
      // eslint-disable-next-line promise/catch-or-return
      import('./sanity-preview.js' /* webpackChunkName: "dh-sg-sanity-preview" */)
    }
  }

  async render() {
    if (this.pageType === 'forside') {
      await import('./client-forside-libs' /* webpackChunkName: "forside-libs" */)
    } else if (this.pageType === 'stilling') {
      await import('./client-stilling-libs' /* webpackChunkName: "stilling-libs" */)
    }

    const { default: CoreDialog } = await import('@nrk/core-dialog')
    if (!customElements.get('core-dialog')) {
      customElements.define('core-dialog', CoreDialog)
    }
  }

  async setupHappyPing() {
    const tracker = await this.coreAnalyticsTracker
    tracker('time-spent', {
      touchMove: true,
    })
  }
  handleActiveChanged = (e) => {
    e.preventDefault()
    this.sendGaEvent({ eventAction: 'ACTIVE-CHANGED', eventLabel: e.detail.nextIndex })
  }

  handleDialogToggle = (event) => {
    if (event.target.id === 'info-dialog') {
      const eventAction = event.target.hidden ? `CLOSE-INFO-DIALOG` : `OPEN-INFO-DIALOG`
      this.sendGaEvent({ eventAction })
    }
  }

  showScrollingAttribute = () => {
    clearTimeout(this.timer)
    if (!this.scrolling) {
      this.scrolling = true
    }

    this.timer = setTimeout(() => {
      this.scrolling = false
    }, 500)
  }

  sendSyntheticMouseMoveEvent = () => {
    let event
    if (typeof Event === 'function') {
      event = new Event('mousemove')
    } else {
      event = document.createEvent('Event')
      event.initEvent('mousemove', true, true)
    }
    document.dispatchEvent(event)
  }

  async sendPageView(page) {
    const tracker = await this.coreAnalyticsTracker
    tracker('pageview', {
      page,
      tnsSection: 'nrk/spesial/sexguiden',
      ga: {
        eventCategory: `dh-modul-${this.name}`,
      },
    })
  }

  get scrolling() {
    return this.hasAttribute('scrolling')
  }

  set scrolling(val) {
    if (val) {
      this.setAttribute('scrolling', 'true')
    } else {
      this.removeAttribute('scrolling')
    }
  }

  get baseUrl() {
    return this.getAttribute('data-base-url')
  }

  get pageType() {
    return this.getAttribute('data-page-type')
  }
}

class SpesialmodulElement extends BaseElement {
  name = tagSpesialmodul

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('dh-basis-sveip-active-changed', this.handleActiveChanged)
  }

  handleActiveChanged = (e) => {
    e.preventDefault()
    this.sendGaEvent({ eventAction: 'ACTIVE-CHANGED', eventLabel: e.detail.nextIndex })
  }

  async render() {
    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })

    const { SpesialmodulSveip } = await import(
      './client-spesialmodul-libs' /* webpackChunkName: "widget-libs" */
    )

    if (!customElements.get('dh-sg-spesialmodul-sveip')) {
      customElements.define('dh-sg-spesialmodul-sveip', SpesialmodulSveip)
    }
  }

  get baseUrl() {
    return this.getAttribute('data-base-url')
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}

if (!customElements.get(tagSpesialmodul)) {
  customElements.define(tagSpesialmodul, SpesialmodulElement)
}
